import React, { useState } from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';
import { exportToCSV, exportLongTermTasksToPDF } from '../../../utils/exportUtils';

const LongTermTaskExportControls = ({ tasks, familyMembers }) => {
  const [showMenu, setShowMenu] = useState(false);

  const handleExportCSV = () => {
    const csvData = tasks?.map(task => ({
      Task: task?.title || '',
      Description: task?.description || '',
      'Assigned To': task?.assignedTo || '',
      'Due Date': task?.dueDate || '',
      Priority: task?.priority || '',
      Status: task?.status || '',
      Progress: `${task?.progress || 0}%`,
      Category: task?.category || '',
      Milestones: task?.milestones?.map(m => m?.title)?.join('; ') || ''
    })) || [];
    
    exportToCSV(csvData, 'long-term-tasks.csv');
    setShowMenu(false);
  };

  const handleExportPDF = () => {
    exportLongTermTasksToPDF(tasks, familyMembers);
    setShowMenu(false);
  };

  return (
    <div className="relative">
      <Button
        variant="outline"
        iconName="download"
        onClick={() => setShowMenu(!showMenu)}
      >
        Export
      </Button>

      {showMenu && (
        <>
          <div 
            className="fixed inset-0 z-40" 
            onClick={() => setShowMenu(false)}
          />
          <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-border z-50">
            <div className="py-2">
              <button
                onClick={handleExportCSV}
                className="w-full px-4 py-2 text-left text-sm hover:bg-gray-50 flex items-center gap-2"
              >
                <Icon name="file-text" size={16} />
                Export as CSV
              </button>
              <button
                onClick={handleExportPDF}
                className="w-full px-4 py-2 text-left text-sm hover:bg-gray-50 flex items-center gap-2"
              >
                <Icon name="file" size={16} />
                Export as PDF
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default LongTermTaskExportControls;